import { IconWrapper } from '../runtime';
export default IconWrapper('wps-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + '00507e0f' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.75 6.75C5.75 6.33579 6.08579 6 6.5 6H7.25C7.66421 6 8 6.33579 8 6.75V14.909L11.2746 11.6344C11.5207 11.3883 11.8546 11.25 12.2027 11.25H12.7973C13.1454 11.25 13.4793 11.3883 13.7254 11.6344L17 14.909V6.75C17 6.33579 17.3358 6 17.75 6H18.5C18.9142 6 19.25 6.33579 19.25 6.75V17.25C19.25 17.6642 18.9142 18 18.5 18H17.4527C17.1046 18 16.7707 17.8617 16.5246 17.6156L12.5 13.591L8.47541 17.6156C8.22927 17.8617 7.89543 18 7.54734 18H6.5C6.08579 18 5.75 17.6642 5.75 17.25V6.75Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '00507e0f',
      "x1": "24.5",
      "y1": "24",
      "x2": "0.5",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0.029618",
      "stop-color": "#0A6CFF"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#29A9FF"
    }
  })])])]);
});